export enum DiabetesStatus {    
    NoProblems = 0,
    MaintainedByLifestyle = 1,
    MaintainedByMeds = 2,
    MaintainedByInsulin = 3
}